import React, { ReactElement } from 'react';
import { Selectable } from 'b2b-components/theme/components/Form/Selectable';
import { withField } from 'b2b-apps/shop/common/components/Form/withField';
import {
  EnhancedComponentType,
  WrappedComponentProps as Props,
  WrappedComponentType as ComponentType,
} from './';

const FormFieldSelectable: ComponentType = (props: Props): ReactElement => {
  const { innerComponentProps, field, form, ...otherProps } = props;

  return (
    <Selectable {...innerComponentProps} {...field} {...otherProps} />
  );
};

const FormFieldSelectableWithField: EnhancedComponentType = withField(FormFieldSelectable);

export {
  FormFieldSelectableWithField as FormFieldSelectable,
  FormFieldSelectable as FormFieldSelectableComponent,
};
